// Formatting helpers for Cash Collections (mirrors the production dashboard).

export const eur = (n: number) => '€' + Math.round(Math.abs(n)).toLocaleString('en-US')
export const eurS = (n: number) => (n < 0 ? '−' : '') + '€' + Math.round(Math.abs(n)).toLocaleString('en-US')
export const eurK = (n: number) => '€' + Math.round(n / 1000).toLocaleString('en-US') + 'k'
export const pct = (part: number, whole: number) => (whole ? (part / whole) * 100 : 0)

/** JetBrains Mono with tabular figures. */
export const MONO = "font-['JetBrains_Mono'] tabular-nums"

/** Accent dot colours from the Cash Collections palette. */
export const DOT: Record<string, string> = {
  green: '#2C7D52',
  tan: '#AE9056',
  red: '#C8453E',
  blue: '#5E6E8C',
}
